import {CARD_RENDER_REQUEST, CARD_RENDER_SUCCESS, CARD_RENDER_FAIL, CARD_RENDER_DELETE_SUCCESS, CARD_RENDER_ALL_DELETE_SUCCESS,RESOLUTION_VALUE_UPDATE_SUCCESS } from "../../actions/types";

const initialState = {
    members: [],

    isLoading: false,
    error: null,

    credits: null,

    currentBlock: { idx: 0, id: null },

    fontStyle: null,

    googleSheetLink: null,
    googleSpreadSheetId: null,

 
    lastSaved: null,
    lastSavedTime: new Date(),
    logos: [],  

    settings: null,

    isVideoGenerated: null,
    renders: [],

    updatedResolutionVal:"1280 x 720"
};

const CardRenderReducer = (state = initialState, action) => {
  switch (action.type) {
    case CARD_RENDER_REQUEST:
      return { ...state, isLoading: true };

    case CARD_RENDER_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload.error,
      };

    case CARD_RENDER_SUCCESS:
      const { renders: _renders } = action.payload;
      return { ...state, renders: [..._renders], isLoading: false };

      case CARD_RENDER_DELETE_SUCCESS:
        const { renderId } = action.payload;
        return {
          ...state,
          renders: [ ...state.renders.filter((project) => project._id !== renderId)],
        };
      
      case CARD_RENDER_ALL_DELETE_SUCCESS:
        const { deleterenders } = action.payload;
        return {
          ...state,
          renders: deleterenders,
        };
       case RESOLUTION_VALUE_UPDATE_SUCCESS:
            return {
              ...state,
              updatedResolutionVal: action.payload,
            };
    default:
      return state;
  }
};

export default CardRenderReducer;